import { close_left_menu, open_left_menu, openHeatingTab, } from 'console/redux/settings-actions';
import { UiGuideGroupKey } from 'console/ui-guide/types';
import { set_service_mode_view } from 'z3k-settings/redux/actions';
const open_left_menu_timeout = 300;
const start_guide_steps = {
    open_left_menu: {
        target: "[data-tooltip='left-menu-button']",
        disableBeacon: true,
        back_callbacks: [close_left_menu],
        timeout: open_left_menu_timeout,
    },
    change_new_ui: {
        target: "[data-tooltip='change-ui-button']",
        forward_callbacks: [open_left_menu],
        timeout: open_left_menu_timeout,
        placement: 'bottom',
    },
    show_sim_button: {
        target: "[data-tooltip='sims-button']",
    },
    show_support_button: {
        target: "[data-tooltip='support-button']",
        back_callbacks: [open_left_menu],
        timeout: open_left_menu_timeout,
    },
    delete_state_tab: {
        target: "[data-tooltip='navigation-bar']",
        forward_callbacks: [close_left_menu],
        timeout: open_left_menu_timeout,
    },
    show_power_icon: {
        target: "[data-tooltip='power-icon']",
    },
    show_connection_icons: {
        target: "[data-tooltip='connection-icons']",
    },
    show_ot_state: {
        target: "[data-tooltip='boiler-card']",
        forward_callbacks: [openHeatingTab],
        timeout: 200,
    },
    show_change_temp_modal: {
        target: "[data-tooltip='heating-circuit-card']",
        forward_callbacks: [openHeatingTab],
        timeout: 200,
        spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
        hideFooter: true,
    },
    show_change_temp_fancy: {
        target: "[data-tooltip='fancy-change-temp']",
        timeout: 800,
        hideBackButton: true,
        disableBeacon: true,
    },
    show_change_temp_button: {
        target: "[data-tooltip='change-temp-buttons']",
    },
    show_change_temp_mode: {
        target: "[data-tooltip='change-temp-mode']",
    },
    show_more_info: {
        target: "[data-tooltip='heating-circuit-widget']",
        spotlightClicks: true,
        hideFooter: true,
        disableOverlay: true,
    },
    close_change_temp_modal: {
        target: "[data-tooltip='heating-circuit-close-handle']",
        timeout: 500,
        disableOverlay: true,
    },
};
const boiler_circuit_steps = {
    show_heating_tab: {
        target: "[data-tooltip='heat-tab-icon']",
        disableBeacon: true,
    },
    show_boiler_card: {
        target: "[data-tooltip='boiler-card']",
        disableBeacon: true,
        forward_callbacks: [openHeatingTab],
        timeout: 800,
        // spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
        // hideFooter: true,
    },
    boiler_name: {
        target: "[data-tooltip='boiler-card-name']",
    },
    fire_icon: {
        target: "[data-tooltip='control-icon']",
    },
    show_go_to_settings: {
        target: "[data-tooltip='go-to-settings']",
    },
    show_water_temp: {
        target: "[data-tooltip='water-temperature']",
    },
    show_set_point_temp: {
        target: "[data-tooltip='set-point-temp']",
    },
    show_control_sensor: {
        target: "[data-tooltip='target-sensor']",
    },
    click_boiler_card: {
        target: "[data-tooltip='boiler-card']",
        spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
        hideFooter: true,
    },
    show_ot_state: {
        target: "[data-tooltip='ot-state-card']",
        timeout: 800,
        disableOverlay: true,
    },
};
const heating_circuit_steps = {
    show_heating_tab: {
        target: "[data-tooltip='heat-tab-icon']",
        disableBeacon: true,
    },
    show_heating_circuit_card: {
        target: "[data-tooltip='heating-circuit-card']",
        disableBeacon: true,
        forward_callbacks: [openHeatingTab],
        timeout: 800,
        // spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
        // hideFooter: true,
    },
    heating_circuit_name: {
        target: "[data-tooltip='heating-circuit-card-name']",
    },
    show_current_temp: {
        target: "[data-tooltip='current-temp']",
    },
    show_heat_request: {
        target: "[data-tooltip='heat-request-icon']",
    },
    show_control_type: {
        target: "[data-tooltip='control-type-icon']",
    },
    show_target_temp: {
        target: "[data-tooltip='target-temp']",
    },
    show_water_temp: {
        target: "[data-tooltip='water-status-temp']",
    },
    show_control_devices_status: {
        target: "[data-tooltip='control-devices-status-temp']",
    },
    show_set_point_temp: {
        target: "[data-tooltip='set-point-status-temp']",
    },
    show_control_sensor: {
        target: "[data-tooltip='target-sensor']",
    },
    click_heating_circuit_card: {
        target: "[data-tooltip='heating-circuit-card']",
        spotlightClicks: true,
        hideFooter: true,
    },
    show_change_temp_fancy: {
        target: "[data-tooltip='fancy-change-temp']",
        timeout: 800,
        hideBackButton: true,
        disableBeacon: true,
    },
    show_change_temp_button: {
        target: "[data-tooltip='change-temp-buttons']",
    },
    show_change_temp_mode: {
        target: "[data-tooltip='change-temp-mode']",
    },
    show_more_info: {
        target: "[data-tooltip='heating-circuit-widget']",
        spotlightClicks: true,
        hideFooter: true,
        disableOverlay: true,
    },
    close_change_temp_modal: {
        target: "[data-tooltip='heating-circuit-close-handle']",
        timeout: 500,
        disableOverlay: true,
    },
};
const simple_ui_steps = {
    show_heating_tab: {
        target: "[data-tooltip='heat-tab-icon']",
        disableBeacon: true,
    },
    show_simple_heating_circuit_card: {
        target: "[data-tooltip='heating-circuit-card']",
        disableBeacon: true,
        forward_callbacks: [openHeatingTab, set_service_mode_view],
        timeout: 600,
        // spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
        // hideFooter: true,
    },
    circuit_card_icon: {
        target: "[data-tooltip='circuit-card-icon']",
        disableBeacon: true,
        timeout: 200,
    },
    modal_button_service_view: {
        target: "[data-tooltip='modal-button-service-view']",
        hideBackButton: true,
        disableBeacon: true,
        hideFooter: true,
        timeout: 200,
        spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
    },
    modal_service_view: {
        target: "[data-tooltip='modal-service-view']",
        hideBackButton: true,
        disableBeacon: true,
        hideFooter: true,
        timeout: 200,
        spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
    },
    modal_message_dialog: {
        target: "[data-tooltip='message-dialog']",
        hideBackButton: true,
        disableBeacon: true,
        hideFooter: true,
        timeout: 200,
        spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
    },
    show_large_heating_circuit_card: {
        target: "[data-tooltip='heating-circuit-card']",
        disableBeacon: true,
        forward_callbacks: [openHeatingTab],
        timeout: 200,
        // spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
        // hideFooter: true,
    },
    open_left_menu: {
        target: "[data-tooltip='card-header-left-menu']",
        forward_callbacks: [open_left_menu],
        timeout: open_left_menu_timeout,
    },
    open_account_setting: {
        target: "[data-tooltip='tariff-balance-section']",
        hideBackButton: true,
        disableBeacon: true,
        timeout: 2300,
        spotlightClicks: true, //можно кликнуть внутрь подсвечиваемой области
    },
    design_package: {
        target: "[data-tooltip='card-design-package']",
        timeout: 200,
    },
};
export const appInfoForUiGuideSteps = {
    [UiGuideGroupKey.start_guide]: start_guide_steps,
    [UiGuideGroupKey.boiler_circuit]: boiler_circuit_steps,
    [UiGuideGroupKey.heating_circuit]: heating_circuit_steps,
    [UiGuideGroupKey.simple_ui]: simple_ui_steps,
};
